module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_vm._v("A note about style")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("All translations follow the New Revised Standard Version ("), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NRSV")]), _vm._v(") unless otherwise indicated in the text. All transliterations follow the General-Purpose Style presented in the "), _c('em', [_vm._v("SBL Handbook of Style")]), _vm._v(". The project was completed during the 2020 COVID-19 quarantine, during which time library access was very limited, with the result that some of the references in the volume are to works earlier than their current editions. Finally, in this volume, I follow the "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NRSV")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" convention of rendering the divine name as ‘the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v("’.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49633d5b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009_A_Note_About.vue
// module id = 81
// module chunks = 0